import React from 'react';
import { useTranslation } from 'react-i18next';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Body, Heading } from '@swyftx/aviary/atoms/Typography';
import { MarginOrderDirection } from '@swyftx/margin/build/types';

import { MarginOrderCloseType } from 'src/lib/margin/types';

import { ClosingPositionsContentSample } from './ClosingPositionsContentSample';

type Props = {
  marginDirection?: MarginOrderDirection;
  closeType?: MarginOrderCloseType;
};

const ClosingPositionsContent: React.FC<Props> = ({ marginDirection, closeType }) => {
  const { t } = useTranslation('margin');

  return (
    <FlexLayout className='p-24' spacing={24} direction='column'>
      <Heading size='h3' weight='light'>
        {t('understandingOrderTypes.close.labels.orderTypes')}
      </Heading>
      <Body color='secondary'>{t('understandingOrderTypes.close.labels.orderTypesContent')}</Body>
      <FlexLayout direction='column' spacing={8}>
        <Heading size='h5'>{t('understandingOrderTypes.close.labels.marketOrders')}</Heading>
        <Body color='secondary'>{t('understandingOrderTypes.close.labels.marketOrdersContent')}</Body>
      </FlexLayout>

      <FlexLayout direction='column' spacing={8}>
        <Heading size='h5'>{t('understandingOrderTypes.close.labels.takeProfitStopLoss')}</Heading>
        <Body color='secondary'>{t('understandingOrderTypes.close.labels.takeProfitStopLossContent')}</Body>
      </FlexLayout>

      <ClosingPositionsContentSample marginDirection={marginDirection} closeType={closeType} />
    </FlexLayout>
  );
};

export { ClosingPositionsContent };
